import { render, staticRenderFns } from "./ContinueWithSMS.vue?vue&type=template&id=48856bfe&"
import script from "./ContinueWithSMS.vue?vue&type=script&lang=js&"
export * from "./ContinueWithSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports